//ALL REACT
import * as React from 'react';
//MUI COMPONENTS
import { Paper, Button, TextField, Box, Tooltip, MenuItem, InputAdornment, IconButton, Typography } from '@mui/material';
//MUI ICONS
import { Clear, Search, SimCardDownload, Queue, EditDocument, ManageAccounts } from '@mui/icons-material';
//API CONTOLLER
import ApiController from '../../controllers/api';
//CUSTOM COMPONENTS
import CustomModal from '../CustomModal';
import CustomBackdrop from '../CustomBackdrop';
import FormCreateArea from '../catalogs/catalogForms/formCreateArea';
import FormEditArea from '../catalogs/catalogForms/formEditArea';
import FormEditOwnerArea from './catalogForms/formEditOwnerArea';
//OTHERS
// COMPONENTS DATAGRID
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import { esES } from '@mui/x-data-grid/locales';
import Swal from 'sweetalert2';

import { usePermissions } from '../../hooks/usePermission';

export default function CatalogArea() {
  const [selectedId, setSelectedIdState] = React.useState(null);
  const [filterValue, setFilterValue] = React.useState('');
  const [getValues, setGetValues] = React.useState([]);
  const [openModal, setOpenModal] = React.useState(null);
  const [openBackdrop, setOpenBackdrop] = React.useState(true);
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
  const { isAuthenticated, canCreate, canEdit, canDelete, canExport, canEditOwner, canViewArea} = usePermissions();

  const apiInstance = React.useMemo(() => new ApiController(process.env.REACT_APP_API_URL), []);
  const apiRef = useGridApiRef();

  const getData = async () => {
  const response = await apiInstance.get('/area');
    if (response.success) {
       setGetValues(response.data);
    }else if(!response.success){
        Swal.fire({
            title: '¡ERROR! ❌',
            icon: 'error',
            text: 'NO SE PUDIERÓN CARGAR LOS DATOS DEL ÁREA',
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonColor:'#ef7474',
            confirmButtonText: 'CONFIRMAR',
            padding: '0 0 20px'
        });
    }
    setOpenBackdrop(false);
  }

  const deleteData = async (id) => await apiInstance.put(`/area/delete/${id}`);

  React.useEffect(() => {
    if(!isAuthenticated || !canViewArea)return;
    getData();
  }, []);

  const handleOpen = (modalType, id = null) => {
    setOpenModal(modalType);
    if (id !== null) setSelectedIdState(id);
  };

  const handleDelete = async (id = "", area = "") => {
    const start = Date.now();
    const result = await Swal.fire({
      title: "DAR DE BAJA ÁREA ⚠️",
      text: `¿ESTAS SEGURO QUE DESEAS DAR DE BAJA ESTA ÁREA ${area}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "SI, DAR DE BAJA",
      confirmButtonColor: "#d80630ff",
      allowOutsideClick: false,
      allowEscapeKey: false
    });
    if (result.isConfirmed) {
        setOpenBackdrop(true);
          const res = await deleteData(id);
          if (res.success) {
            Swal.mixin({
              toast: true,
              position: "bottom-start",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true
            }).fire({
              icon: "success",
              title: "ÁREA DADA DE BAJA",
              text: "EL ÁREA SE DIO DE BAJA CORRECTAMENTE"
            });
            getData();
          } else if(!res.success){
            Swal.fire({
                title: '¡ERROR! ❌',
                icon: 'error',
                text: 'NO SE PUDO DAR DE BAJA ESTA ÁREA',
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonColor:'#ef7474',
                confirmButtonText: 'CONFIRMAR',
                padding: '0 0 20px'
              });
          }
          const elapsed = Date.now() - start;
          const minTime = 1500;
          if (elapsed < minTime) await new Promise(resolve => setTimeout(resolve, minTime - elapsed));
          setOpenBackdrop(false);
    }
  };
  const handleExport = () => {// EXPORTAR SOLO LAS FILAS SELECCIONADAS
  apiRef.current.exportDataAsCsv({
    fileName: 'NOPALA DE VILLAGRÁN - SISTEMA DE INVENTARIOS MUNICIPAL (CATALOGO DE ÁREAS)',
    fields: columns.filter(col => !col.disableExport).map(col => col.field),
    getRowsToExport: () => rowSelectionModel,
    utf8WithBom: true
  });
    // apiRef.current.exportDataAsCsv(); //EXPORTAR TODO
  };
  const handleClose = () => setOpenModal(null);
  const columns = React.useMemo(() => [
    { field: 'CODIGO', headerName: 'CÓDIGO DEL ÁREA', width: 160 , type: 'text'},
    { field: 'NOMBRE', headerName: 'NOMBRE DEL ÁREA', width: 220 , type: 'text'},
    {
      field: 'RESPONSABLE',
      headerName: 'RESPONSABLE DEL ÁREA',
      type: 'text',
      width: 200,
      valueGetter: (value, row) => `${row.ABREV || ''}. ${row.RESPONSABLE || ''}`
    },
    {
      field: 'DESCRIPCION_CARGO',
      headerName: 'DESCRIPCIÓN DEL CARGO',
      width: 220,
      sortable: false,
      type: 'text',
      renderCell: (params) => (
        <Typography
          variant="body2"
          style={{
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'auto',
            textOverflow: 'ellipsis',
            whiteSpace: 'normal'
          }}
        >
          {params.value || ''}
        </Typography>
      )
    },
    {field: 'SUPERIOR_JERARQUICO',
      headerName: 'ÁREA SUPERIOR EN JERARQUÍA',
      type: 'text',
      width: 250
    },
    { field: 'EDIFICIO', headerName: 'EDIFICIO ASIGNADO', width: 200 , type: 'text'},
    {
      field: 'ACCIONES',
      headerName: 'ACCIONES',
      sortable: false,
      flex: 1,
      minWidth: 235,
      disableExport: true,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: "break-word", width: "fit-content" }}>
          {canEditOwner && (
          <Tooltip title="CAMBIAR DE TITULAR DE ÁREA" placement="bottom-start">
            <Button
              variant="contained"
              size="small"
              color="error"
              style={{ marginRight: 10 }}
              onClick={() => handleOpen("change_owner", params.row.ID)}
              sx={{
                backgroundColor: "#990E3F",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#870C38"
                }
              }}
            >
              <ManageAccounts />
            </Button>
          </Tooltip>
          )}
          {canEdit && (
          <Tooltip title="ACTUALIZAR" placement="bottom-start">
            <Button
              variant="contained"
              size="small"
              color="primary"
              onClick={() => handleOpen("edit", params.row.ID)}
              style={{ marginRight: 10 }}
            >
              <EditDocument />
            </Button>
          </Tooltip>
          )}
          {canDelete && (
          <Tooltip title="DAR DE BAJA" placement="bottom-start">
            <Button
              variant="contained"
              size="small"
              color="error"
              onClick={() => handleDelete(params.row.ID, params.row.NOMBRE)}
            >
              <SimCardDownload />
            </Button>
          </Tooltip>
          )}
        </div>
      )
    }
  ], [canEdit, canDelete, canEditOwner]);
  
  const filterableColumns = columns.filter(col => col.field !== 'ACCIONES' && col.field !== 'DESCRIPCION_CARGO');
  const [filterColumn, setFilterColumn] = React.useState(filterableColumns[0].field);
  const currentColumnType = columns.find(col => col.field === filterColumn)?.type || 'text';
  const filteredRows = React.useMemo(() => {
    if (!filterValue) return getValues || [];
    return (getValues || []).filter(row => {
      const value = row[filterColumn];
      if (value === null || value === undefined) return false;
      return value.toString().toLowerCase().includes(filterValue.toLowerCase());
    });
  }, [getValues, filterColumn, filterValue]);

  return (
    <>
        <Paper sx={{ background: "transparent", border: "none", boxShadow:"none", height: "auto", width: '90%', minWidth: 300, maxWidth: 1540, p: 2, margin: "auto", marginTop: "100px" }}>
          <Typography variant="h6" fontWeight={500}>CATÁLOGO DE <b>ÁREAS</b></Typography>
        </Paper>
      <Paper sx={{ height: "auto", width: '90%', minWidth:300, maxWidth: 1540, p: 2, margin: "auto", marginBottom: "50px" }}>
        <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap'}}>
          <TextField
            select
            label="BUSCAR POR"
            value={filterColumn}
            onChange={e => setFilterColumn(e.target.value)}
            size="small"
          >
            {filterableColumns.map(col => (
              <MenuItem key={col.field} value={col.field}>{col.headerName}</MenuItem>
            ))}
          </TextField>
          <TextField
            label="BUSCAR"
            variant="outlined"
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
            size="small"
            type={currentColumnType}
            autoComplete='false'
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  {filterValue && (
                    <IconButton
                      aria-label="clear search"
                      onClick={() => setFilterValue("")}
                      edge="end"
                    >
                      <Clear />
                    </IconButton>
                  )}
                </InputAdornment>
              ),
            }}
          />
          {canCreate && (
          <Tooltip title="AGREGAR NUEVO" placement="bottom-start">
          <Button variant="contained" size="small" color="success" onClick={() => handleOpen("create")}>
            <Queue />
          </Button>
          </Tooltip>
          )}
          {canExport && (
          <Tooltip title="EXPORTAR A SVG" placement="bottom-start">
              <Button
              variant="contained" 
              size="small"
              onClick={handleExport}
              disabled={rowSelectionModel.length === 0}
              sx={{
                backgroundColor: "#aac101ff",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#9baf02ff"
                }
              }}
              >
                <SimCardDownload/>
              </Button>
          </Tooltip>
          )}
        </Box>
        <DataGrid
          apiRef={apiRef}//REFERENCIA PARA EXPORTAR
          disableColumnMenu// DESACTIVA EL MENU DE COLUMNA
          checkboxSelection// HABILITA LA SELECCIÓN DE FILAS
          disableRowSelectionOnClick// EVITA QUE SELECCIONE LA FILA AL DAR CLICK EN ELLA
          rows={filteredRows}// FILAS A MOSTRAR
          columns={columns}// COLUMNAS A MOSTRAR
          getRowHeight={() => 50}// ALTO DE FILA AUTOMATICO
          getRowId={(row) => row.ID}// LLAVE UNICA DE CADA FILA
          initialState={{ pagination: { paginationModel: { page: 0, pageSize: 10 } } }}// ESTADO INICIAL DE LA PAGINACION
          pageSizeOptions={[5, 10, 15, 20, 25, 30]}// OPCIONES DE PAGINACION
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}// IDIOMA A ESPAÑOL
          onRowSelectionModelChange={(newSelection) => {// OBTENER LAS FILAS SELECCIONADAS
            if (!newSelection) return;
              const idSelection = Array.from(newSelection.ids);
              setRowSelectionModel(idSelection);
          }}
          sx={{
            '& .MuiDataGrid-cell': {
              borderRight: '1px solid #f7f8f8',
            },
            '& .MuiDataGrid-columnHeaders': {
              borderBottom: '3px solid #823c3c',
            },
            '& .MuiDataGrid-row': {
              borderBottom: '1px solid #f7f8f8',
            }
          }}
        />
        <CustomModal open={openModal === 'edit'} onClose={handleClose} id={selectedId} Component={FormEditArea} refreshArea={getData} />
        <CustomModal open={openModal === 'change_owner'} onClose={handleClose} id={selectedId} Component={FormEditOwnerArea} refreshArea={getData} />
        <CustomModal open={openModal === 'create'} onClose={handleClose} Component={FormCreateArea} refreshArea={getData}/>
      </Paper>
      <CustomBackdrop open={openBackdrop}/>
    </>
  );
}